import React from 'react';
import { CheckIcon, BookOpenIcon, ListChecksIcon, CalendarIcon } from 'lucide-react';
import { trackPurchase } from './MetaPixel';
export const Solution = () => {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-310">
      <div className="max-w-7xl mx-auto" data-id="element-311">
        <div className="text-center mb-12" data-id="element-312">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-313">
            El Método 3C™ que transforma tu cocina
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-314">
            No sos "inconstante". Sos estratégica, si tenés un sistema.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-315">
          <div className="flex justify-center order-2 md:order-1" data-id="element-316">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rij2P2V1dYdfYbDZEfc2LB/7fef2dcc-33f9-46e3-aef0-0537d0a12c83.png" alt="Recetario Fit para Airfryer" className="rounded-lg shadow-xl w-full max-w-md" data-id="element-317" />
          </div>
          <div className="space-y-6 order-1 md:order-2" data-id="element-318">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-319">
              <div className="flex items-center gap-4 mb-3" data-id="element-320">
                <div className="bg-teal-100 p-2 rounded-full" data-id="element-321">
                  <CheckIcon className="h-6 w-6 text-teal-600" data-id="element-322" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-323">Crocante</h3>
              </div>
              <p className="text-gray-700 pl-12" data-id="element-324">
                Reglas simples para textura "wow" sin aceite.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-325">
              <div className="flex items-center gap-4 mb-3" data-id="element-326">
                <div className="bg-teal-100 p-2 rounded-full" data-id="element-327">
                  <ListChecksIcon className="h-6 w-6 text-teal-600" data-id="element-328" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-329">Control</h3>
              </div>
              <p className="text-gray-700 pl-12" data-id="element-330">
                Macros claros según tu objetivo (déficit, mantenimiento o
                músculo).
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-331">
              <div className="flex items-center gap-4 mb-3" data-id="element-332">
                <div className="bg-teal-100 p-2 rounded-full" data-id="element-333">
                  <CalendarIcon className="h-6 w-6 text-teal-600" data-id="element-334" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-335">
                  Consistencia
                </h3>
              </div>
              <p className="text-gray-700 pl-12" data-id="element-336">
                Plan semanal + batch cooking 2 veces por semana.
              </p>
            </div>
            <div className="mt-8 flex justify-center md:justify-start" data-id="element-337">
              <a href="https://vhwt09-gz.myshopify.com/checkouts/cn/hWN3ajyOi9gyqJJTJgcXUW4g/es-ar?cart_link_id=CISumiVv&preview_theme_id=133233049643" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 text-lg" onClick={trackPurchase} data-id="element-338">
                Quiero todo hoy solo por $19.990
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};